import type { UsPreJoinValues } from "../schemas/us-pre-join.schema.ts";

export type UsPreJoinSignupPayload = {
  personalEmail: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  bloodGroup: null;
  dob: string;
  passportNum: string;
  doj: string;
  maritalStatus: string;
  anniversaryDate: string | null;
  phoneNumber: string;
  alternateNumber: string;
  contactName: string;
  relationWithAlternateNo: string;
  alternateName: string;
  presentAddress: string;
  permanentAddress: string;
  ssn: string;
  zipCode: string;
  token: string;
};

function formatUsPhone(value: string): string {
  const digits = value.replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return value.trim();
  return `+1-${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function titleCase(value: string): string {
  return value
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function buildUsPreJoinSignupPayload(
  values: UsPreJoinValues,
  token: string,
): UsPreJoinSignupPayload {
  return {
    personalEmail: values.personalEmail.trim(),
    firstName: values.firstName.trim(),
    middleName: values.middleName?.trim() ?? "",
    lastName: values.lastName.trim(),
    gender: titleCase(values.gender),
    bloodGroup: null,
    dob: values.dob,
    passportNum: values.passportNumber.trim(),
    doj: values.joiningDate,
    maritalStatus: values.maritalStatus,
    anniversaryDate:
      values.maritalStatus === "Married" && values.anniversaryDate
        ? values.anniversaryDate
        : null,
    phoneNumber: formatUsPhone(values.phoneNumber),
    alternateNumber: formatUsPhone(values.emergencyContactNumber),
    contactName: values.emergencyContactName.trim(),
    relationWithAlternateNo: values.emergencyRelationship,
    alternateName: values.emergencyContactName.trim(),
    presentAddress: values.presentAddress.trim(),
    permanentAddress: values.permanentAddress?.trim() ?? "",
    ssn: values.ssn.trim(),
    zipCode: values.zipCode.replace(/\D/g, ""),
    token,
  };
}
